import { supabase } from '@/lib/supabase'
import type { MonthlySavePlan } from './monthlyRecordsSave'

export async function saveMonthlyRecords(plan: MonthlySavePlan) {
  const { data, error } = await supabase.rpc('save_monthly_records', {
    p_month: plan.month,
    p_base_snapshot_id: plan.baseSnapshotId,
    p_rows: plan.snapshotRows,
    p_edits: plan.utilityEdits,
  })
  if (error) throw new Error(error.message)
  const result = data?.[0]
  if (!result) throw new Error('Monthly save returned no result')
  return result
}
